import template from './contact-groups.html';
import controller from './contact-groups.controller';

export default {
    template,
    controller,
    controllerAs: '$ctrl',
    bindings: {
        organizationId: '<',
        contactGroups: '<',
        loadingContactGroups: '<',
        onLoadContactGroups: '&',
        onCreateContactGroup: '&',
        onUpdateContactGroup: '&',
        onDeleteContactGroup: '&',
        onShowContactGroupsInfo: '&',
        onShowBulkEditModal: '&'
    }
}; 